/**
 * This class is responsible for interfacing with Session storage on behalf of the app
 */
import { username } from '@/user/user-selectors';

export class UserSessionMgr {
  static LIST_VIEW_TAB = 'listViewTab';

  static LIST_VIEW_TAB_CONFIG = 'listViewTabConfig';

  static PROPERTY_DETAILS_TAB = 'propertyDetailsTab';

  static DEFAULT_PLACE = 'defaultPlace';

  static RELEASE_TOKEN = 'release_token';

  constructor() {
    /*
     * These instance variables keep track of what needs to be remembered. It's done like this
     * is faster than constantly reading and writing so sessionStorage
     */
    this.propertyDetailsTab = this.getPropertyDetailsTab();
    this.listViewTab = this.getListViewTab();
    this.listViewTabConfig = this.getListViewTabConfig();
    this.defaultPlace = this.getDefaultCitySession();
    this.releaseToekn = this.getReleaseTokenSession(username);

    // register event listener that write to session storage
    this.registerEventListeners();
  }

  setListViewTab = (tabName, tabConfig) => {
    if (!tabName)
      window.sessionStorage.removeItem(UserSessionMgr.LIST_VIEW_TAB);
    else window.sessionStorage.setItem(UserSessionMgr.LIST_VIEW_TAB, tabName);

    if (!tabConfig)
      window.sessionStorage.removeItem(UserSessionMgr.LIST_VIEW_TAB_CONFIG);
    else
      window.sessionStorage.setItem(
        UserSessionMgr.LIST_VIEW_TAB_CONFIG,
        tabConfig
      );
  };

  getListViewTab = () =>
    window.sessionStorage.getItem(UserSessionMgr.LIST_VIEW_TAB);

  getListViewTabConfig = () =>
    window.sessionStorage.getItem(UserSessionMgr.LIST_VIEW_TAB_CONFIG);

  setPropertyDetailsTab = (tabName) => {
    if (!tabName) {
      window.sessionStorage.removeItem(UserSessionMgr.PROPERTY_DETAILS_TAB);
    } else {
      window.sessionStorage.setItem(
        UserSessionMgr.PROPERTY_DETAILS_TAB,
        tabName
      );
    }
  };

  getPropertyDetailsTab = () =>
    window.sessionStorage.getItem(UserSessionMgr.PROPERTY_DETAILS_TAB);

  setDefaultCitySession = (defaultPlace, username) => {
    const userSessionDefaultCityKey = `${UserSessionMgr.DEFAULT_PLACE}.${username}`;
    if (!defaultPlace) {
      window.sessionStorage.removeItem(userSessionDefaultCityKey);
    } else {
      window.sessionStorage.setItem(userSessionDefaultCityKey, defaultPlace);
    }
  };

  getDefaultCitySession = (username) =>
    window.sessionStorage.getItem(
      `${UserSessionMgr.DEFAULT_PLACE}.${username}`
    );

  setReleaseTokenSession = (release_token, username) => {
    const userReleaseKey = `${UserSessionMgr.RELEASE_TOKEN}.${username}`;
    if (!release_token) {
      window.sessionStorage.removeItem(userReleaseKey);
    } else {
      window.sessionStorage.setItem(userReleaseKey, release_token);
    }
  };

  getReleaseTokenSession = (username) =>
    window.sessionStorage.getItem(
      `${UserSessionMgr.RELEASE_TOKEN}.${username}`
    );

  /**
   * Record states in session storage
   */
  rememberStates = () => {
    this.setPropertyDetailsTab(this.propertyDetailsTab);
    this.setListViewTab(this.listViewTab, this.listViewTabConfig);
    this.setDefaultCitySession(this.defaultPlace);
  };

  /**
   * Registers beforeunload event listener. Whenever the user unloads the page, we'll store
   * the information we want to remember in session storage.
   */
  registerEventListeners = () => {
    /*
     * We're saving some values into session storage only when the user reloads the page.
     * This is done so that don't have to constantly write to sessionStorage when these values are
     * unused
     */
    window.addEventListener('beforeunload', this.rememberStates);
  };

  clear = () => {
    window.sessionStorage.removeItem(UserSessionMgr.PROPERTY_DETAILS_TAB);
    window.sessionStorage.removeItem(UserSessionMgr.LIST_VIEW_TAB);
    window.sessionStorage.removeItem(UserSessionMgr.DEFAULT_PLACE);
    this.propertyDetailsTab = null;
    this.listViewTab = null;
    this.defaultPlace = null;
  };
}

export const userSessionMgr = new UserSessionMgr();
window.userSessionMgr = userSessionMgr;
